/* eslint-disable */
import React from 'react'
import {Icon, message} from 'antd'
import {Link} from 'react-router-dom'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import http from '../Interceptor/Interseptor'
import SinglePicker from '../BaseComponent/singlePicker'
import {ExcelExport, grid, gridColumn} from '@progress/kendo-react-excel-export'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import Select from 'react-select'
import Loader from '../loaders/loader'
jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})

class SupplyOrderStatus extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      shiftDate: null,
      excel: [],
      deliveryLocations: [],
      deliveryLocation: [],
      deliveryBehaviours: [],
      deliveryBehaviour: []
    }
  }
  componentDidMount() {
    http.get(`report/retail/list/delivery-behaviour`, {}).then((response) => {
      if (response.data.error == null) {
        let result = response.data.object
        for (let i = 0; i < result.length; i++) {
          result[i]['value'] = result[i].deliveryBehaviourId
          result[i]['label'] = result[i].name
        }
        this.setState({
          deliveryBehaviours: result
        })
      }
    })
    http.get(`report/retail/list/delivery-location`, {}).then((response) => {
      if (response.data.error == null) {
        let result = response.data.object
        for (let i = 0; i < result.length; i++) {
          result[i]['value'] = result[i].deliveryLocationId
          result[i]['label'] = result[i].name
        }
        this.setState({
          deliveryLocations: result
        })
      }
    })
  }

  handleDateChange = (shiftDate) => {
    this.setState({shiftDate})
  }

  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  submit(e) {
    e.preventDefault()
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  changeDeliveryBehavior = (deliveryBehaviour) => {
    this.setState({deliveryBehaviour})
  }
  changeDeliveryLocation = (deliveryLocation) => {
    this.setState({deliveryLocation})
  }

  getReport() {
    let shiftDate = this.state.shiftDate
    let deliveryBehaviour = this.state.deliveryBehaviour.length === 0 ? [] : this.state.deliveryBehaviour
    let deliveryLocation = this.state.deliveryLocation.length === 0 ? [] : this.state.deliveryLocation
    let behaviorArr = []
    deliveryBehaviour.forEach((item) => {
      behaviorArr.push(item.deliveryBehaviourId)
    })

    let locationArr = []
    deliveryLocation.forEach((item) => {
      locationArr.push(item.deliveryLocationId)
    })
    if (shiftDate === null) {
      message.error('تاریخ وارد شود')
    } else {
      JASPERREPORT(
        `report/jasper/dispatch/master/supply-order/status?shiftDate=${this.epochFrom(
          shiftDate
        )}&deliveryBehaviour=${behaviorArr}&deliveryLocation=${locationArr}`
      )
    }
  }
  getExcel() {
    let shiftDate = this.state.shiftDate
    let deliveryBehaviour = this.state.deliveryBehaviour.length === 0 ? [] : this.state.deliveryBehaviour
    let deliveryLocation = this.state.deliveryLocation.length === 0 ? [] : this.state.deliveryLocation
    let behaviorArr = []
    deliveryBehaviour.forEach((item) => {
      behaviorArr.push(item.deliveryBehaviourId)
    })

    let locationArr = []
    deliveryLocation.forEach((item) => {
      locationArr.push(item.deliveryLocationId)
    })
    if (shiftDate === null) {
      message.error('تاریخ وارد شود')
    } else {
      this.setState({
        loading: true
      })
      // JASPERREPORT(`report/jasper/dispatch/master/supply-order/incomplete?shiftDate=${((shiftDate))}`)
      http
        .get(
          `report/jasper/dispatch/master/supply-order/status/json?shiftDate=${this.epochFrom(
            shiftDate
          )}&deliveryBehaviour=${behaviorArr}&deliveryLocation=${locationArr}`
        )
        .then((res) => {
          this.setState({
            loading: false
          })
          if (res.data.error === null) {
            let result = res.data.object.supplyOrderMasterStatusReportViewList.map((item) => ({...item}))
            this.setState(
              {
                excel: result
              },
              () => {
                this._export.save(this.state.excel)
              }
            )
          }
        })
        .catch(() => {
          this.setState({
            loading: false
          })
        })
    }
  }

  date(props) {
    return <input className="form-control" {...props} />
  }

  render() {
    return (
      <div className="rtl">
        <Loader show={this.state.loading} />
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش وضعیت سفارش تامین کنندگان.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excel}>
              <gridColumn
                key={'sellerId'}
                field={'sellerId'}
                title={'شناسه'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'sellerName'}
                field={'sellerName'}
                title={'تامین کننده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'deliveryLocation'}
                field={'deliveryLocation'}
                title={'محل تحویل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'deliveryBehaviour'}
                field={'deliveryBehaviour'}
                title={'رفتار تحویل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li>گزارش وضعیت سفارش تامین کنندگان</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>گزارش وضعیت سفارش تامین کنندگان</p>
            </div>

            <div className="formComponent">
              <label className="font-weight-bold">
                تاریخ :<span className="requireFiled font-weight-bold">*</span>
              </label>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DatePicker
                  inline
                  okLabel="تأیید"
                  autoOk={true}
                  leftArrowIcon={<Icon type="left" />}
                  rightArrowIcon={<Icon type="right" />}
                  cancelLabel="لغو"
                  labelFunc={(shiftDate) => (shiftDate == null ? '' : shiftDate.format('jYYYY/jM/jDD'))}
                  value={this.state.shiftDate}
                  id="date"
                  onChange={this.handleDateChange}
                  TextFieldComponent={this.date}
                  readOnly
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className="formComponent selectComponent">
              <label>محل تحویل :‌</label>
              <Select
                value={this.state.deliveryLocation}
                onChange={this.changeDeliveryLocation}
                options={this.state.deliveryLocations}
                isMulti={true}
                isClearable={true}
                placeholder={''}
                id="deliveryLocation"
                name="deliveryLocation"
              />
            </div>
            <div className="formComponent selectComponent">
              <label>رفتار تحویل :‌</label>
              <Select
                value={this.state.deliveryBehaviour}
                onChange={this.changeDeliveryBehavior}
                options={this.state.deliveryBehaviours}
                isMulti={true}
                isClearable={true}
                placeholder={''}
                id="deliveryBehavior"
                name="deliveryBehavior"
              />
            </div>

            <div className="formComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getReport.bind(this)}>
                گزارش وضعیت سفارش تامین کنندگان
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getExcel.bind(this)}>
                خروجی اکسل وضعیت سفارش تامین کنندگان
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default SupplyOrderStatus
